export const SET_QRCODE = 'SET_QRCODE';
export const INIT_QRCODE = 'INIT_QRCODE';
export const CLEAN_QRCODE = 'CLEAN_QRCODE';
export const SWITCH_MODAL_SHOW = 'SWITCH_MODAL_SHOW';
export const INIT_QRCODE_STA = 'INIT_QRCODE_STA';
export const SAVE_CLOSE_DATE = 'SAVE_CLOSE_DATE';
export const SAVE_MP_WATCH = 'SAVE_MP_WATCH';
export const IS_LOGIN = 'IS_LOGIN';
export const PAY_OK = 'PAY_OK';
export const IS_SHOW_MODAL = 'IS_SHOW_MODAL';
export const QRCODE_GET = 'QRCODE_GET';



// WEBPACK FOOTER //
// ./src/store/modules/follow-official-accounts/follow-official-accounts-types.js